import axios from 'utils/axios';

export const getAssessorWiseDetails = async (params: any) => {
  return await axios.get('/assessorWiseDetails', { params });
};

export const getDashboardCounts = async () => {
  return await axios.get('/assessorWiseDetails/dashboard-counts');
};

export type ReassessmentNosParams = {
  assessmentSessionId: string;
  studentId?: string;
  /** Optional; should match session `type` (e.g. `reassessment`). Sent as query `type`. */
  type?: string;
};

export const reassessmentNos = async (params: ReassessmentNosParams) => {
  return await axios.get('/assessorWiseDetails/reassessmentNos', { params });
};
